import styled from "styled-components";

import withCssUnit from "./withCssUnit";

const DivWithMargin = styled.div`
  margin-left: ${(props) => withCssUnit(props?.marginLeft)};
  margin-right: ${(props) => withCssUnit(props?.marginRight)};
`;

export default DivWithMargin;
